import { render, staticRenderFns } from "./details-section.vue?vue&type=template&id=0580a1b3&scoped=true&"
import script from "./details-section.vue?vue&type=script&lang=js&"
export * from "./details-section.vue?vue&type=script&lang=js&"
import style0 from "./details-section.vue?vue&type=style&index=0&id=0580a1b3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0580a1b3",
  null
  
)

export default component.exports